<template>
  <v-footer v-if="footerContent" class="footer">
    <div class="footer-wrapper v-main">
      <div class="footer-content">
        <div v-html="parsedFooterContent"></div>
      </div>
    </div>
  </v-footer>
</template>

<script>
import _ from 'lodash'
import {mapGetters} from 'vuex'
import {resolveUrlPlaceholders} from '@/utils/urlHelpers'

export default {
  name: 'Footer',
  computed: {
    ...mapGetters(['extensionSettings', 'isAuthenticated']),
    footerContent() {
      return _.get(
        this.extensionSettings, 'webview.footer.content', ''
      )
    },
    parsedFooterContent() {
      if (this.footerContent) {
        return resolveUrlPlaceholders(this.footerContent)
      }

      return ''
    }
  },
  watch: {
    footerContent(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.modifyAnchors()
        })
      }
    }
  },
  mounted() {
    if (this.footerContent) {
      this.modifyAnchors()
    }
  },
  methods: {
    modifyAnchors() {
      const anchors = this.$el.querySelectorAll('a')

      anchors.forEach((anchor) => {
        anchor.setAttribute('target', '_blank')
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  padding: 42px 0;
  background-color: var(--footer-background, #000);
}

.footer-content {
  color: var(--footer-color, #fff);
  text-align: center;
  margin: 0 auto;

  &::v-deep {
    * {
      color: inherit;
    }

    ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0;
      margin: 0 0 6px;
      list-style-type: none;

      li {
        margin: 0 12px 6px;
      }
    }
  }
}
</style>
